import Environment from '@cobliteam/react-environments';
import { createClient } from '@prismicio/client';
import type { AllDocumentTypes } from './types/herbie-dashboard.generated';

const env = Environment.getInstance().getEnvironment();

export const repositoryName = env.prismicRepositoryDashboard;

const client = createClient<AllDocumentTypes>(repositoryName, {
  routes: [
    { type: 'home_banner', path: '/home' },
    { type: 'login_page', path: '/login' },
  ],
});

export default client;
